import { Container } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import * as React from "react";
import { useForm } from "react-hook-form";
import Header from "../common/LoginHeader";

import { useDispatch, useSelector } from "react-redux";
import { login } from "../../redux/actions/auth";

export default function Signin() {
  const { register, handleSubmit } = useForm();
  const dispatch = useDispatch();

  const message = useSelector(state => state.auth.message);
  const messageCode = useSelector(state => state.auth.message_code);
  const onSubmit = data => {
    dispatch(login(data));
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Header />
      <Container maxWidth="sm">
        <Box
          sx={{
            marginTop: 9,
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Typography component="h5" variant="h6" align="left">
            ログイン
          </Typography>
        </Box>
        <Box
          sx={{
            marginTop: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            bgcolor: "#fff9c4"
          }}
        >
          {messageCode && message && 
            <span style={{color: "red", paddingTop: "1rem"}}>
              {messageCode}
              <br />
              {message}
            </span>
          }
          <Box component="form" noValidate sx={{ mt: 3 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              label="メールアドレス"
              name="email"
              type="email"
              id="email"
              {...register("email", {
                required: "メールアドレス入力してください。"
              })}
              sx={{ background: "white" }}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              label="パスワード"
              name="password"
              type="password"
              id="password"
              autoComplete="current-password"
              {...register("password", {
                required: "パスワードを入力してください。"
              })}
              sx={{ background: "white" }}
            />
            <Button
              type="submit"
              variant="contained"
              sx={{ mt: 3, mb: 2, bgcolor: "#82b1ff" }}
              onClick={handleSubmit(onSubmit)}
            >
              ログイン
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
